// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aQpe","rootMobile":"styles_rootMobile__2WjJD"};